import StripeRedirect from "shared/components/handleRedirects/stripeRedirect";

export default function MyExpPaymentStatus() {
  return <StripeRedirect />;
}
